import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';

import actions from './actions';
import getters from './getters';
import mutations from './mutations';
import state from './state';
import urlStorage from './storage/urlStorage';

import authBuffer from './modules/authBuffer';
import map from './modules/map';
import panorama from './modules/panorama';
import permissions from './modules/permissions';
import polygon from './modules/polygon';
import search from './modules/search';
import track from './modules/track';

Vue.use(Vuex);

export default new Vuex.Store({
    state,
    getters,
    mutations,
    actions,

    modules: {
        authBuffer,
        map,
        panorama,
        permissions,
        polygon,
        search,
        track,
    },

    plugins: [
        createPersistedState({
            paths: ['panorama', 'map', 'search'],
            storage: urlStorage(),
        }),
        createPersistedState({
            paths: ['apiKey', 'momaKey'],
        }),
    ],
});
